import { forwardRef, useId } from "react";
import Icon from "~/components/shared/Icon";
import Spinner from "~/components/shared/Spinner";

interface Props extends React.HTMLProps<HTMLInputElement> {
  isPending?: boolean;
}

/** @deprecated Use `~/components/build/Show/routes/list/-components/StepSearch/StepSearchInput` instead. */
export const StepSearchInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const id = useId();

  return (
    <div className="relative flex max-w-full items-center">
      <label htmlFor={id} className="sr-only">
        Search steps
      </label>

      <input
        {...props}
        id={id}
        ref={ref}
        placeholder=""
        className="input focus:outline-hidden peer px-2 py-1 text-sm focus:border-transparent focus:ring-2 focus:ring-purple-600"
      />
      <span
        className="text-charcoal-300 pointer-events-none absolute flex w-full items-center gap-1 truncate px-2 text-left peer-[:not(:placeholder-shown)]:hidden"
        aria-hidden="true"
      >
        <Icon icon="heroicons/16/solid/magnifying-glass" className="h-4 w-4" />
        <span>Search for step&hellip;</span>
      </span>

      {props.isPending && <Spinner className="absolute right-2 z-10 h-4 w-4" />}
    </div>
  );
});
